// Computes the wizard's step keys from usage_type (and, for marketplace API
// campaigns, from the chosen marketplace).
//   Marketplace API campaigns (marketplaceApi set): basics -> mp_connect -> mp_products -> pricing.
//   Scraping campaigns (default): basics -> products -> sites -> price_check -> (pricing|map?) -> search_match.
//   Pricing/MAP step: seller -> 'pricing', manufacturer -> 'map'.
//                      drop_shipping / market_search -> NO such step.
//   "Search & Match" (search_match) is always the LAST step for scraping campaigns.
export const wizardStepKeys = (usageType, marketplaceApi) => {
    if (marketplaceApi) return ['basics', 'mp_connect', 'mp_products', 'pricing'];
    const keys = ['basics', 'products', 'sites', 'price_check'];
    if (usageType === 'seller') keys.push('pricing');
    else if (usageType === 'manufacturer') keys.push('map');
    keys.push('search_match');
    return keys;
};
